// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__W94Pr","link":"tweet-replies_link__PdykC","text":"tweet-replies_text__0vImx"};